import React from "react";
import PitchesHomeRoutes from "../../../views/Pitches/PitchesHomeRoutes";

export default props => <PitchesHomeRoutes client={props.client} clientId={props.client.id} {...props} />

